import React from 'react'; // Importamos React
import PropTypes from 'prop-types';
import './video.styles.css';

export default function YoutubeComponent({ videoPlayer }) {
  //  shouldComponentUpdate() {}

  return (
    <div
      id={`contenedor-${videoPlayer.videoData.idYoutubeElement}`}
      className="tpx-youtube-container"
      width={'100%'}
      height={'100%'}
    >
      <div id={videoPlayer.videoData.idYoutubeElement}></div>
    </div>
  );
}

YoutubeComponent.propTypes = {
  videoPlayer: PropTypes.object.isRequired,
};
